import { gql } from '@anyx/common-graphql';

export const GET_ALL_INFLUENCER_CAMPAIGNS = gql(/* GraphQL */ `
  query GetAllInfluencerCampaigns(
    $storeId: Long!
    $keyword: String
    $status: InfluencerCampaignStatus!
    $offset: Int!
    $limit: Int!
  ) {
    AllInfluencerCampaigns(
      input: {
        storeId: $storeId
        keyword: $keyword
        status: $status
        offset: $offset
        limit: $limit
      }
    ) {
      total
      records {
        id
        campaignType
        name
      }
    }
  }
`);

export const GET_SINGLE_AND_ALL_INFLUENCER_CAMPAIGNS = gql(/* GraphQL */ `
  query GetSingleAndAllInfluencerCampaigns(
    $campaignId: Long!
    $campaignType: InfluencerCampaignType!
    $storeId: Long!
    $keyword: String
    $status: InfluencerCampaignStatus!
    $offset: Int!
    $limit: Int!
  ) {
    InfluencerCampaignsByIds(
      input: { campaigns: [{ id: $campaignId, campaignType: $campaignType }] }
    ) {
      id
      campaignType
      name
    }

    AllInfluencerCampaigns(
      input: {
        storeId: $storeId
        keyword: $keyword
        status: $status
        offset: $offset
        limit: $limit
      }
    ) {
      total
      records {
        id
        campaignType
        name
      }
    }
  }
`);

export const GET_CUSTOMER_LIST_WITH_TAG = gql(/* GraphQL */ `
  query GetCustomerListWithTag(
    $storeId: Long!
    $chatTypeFilter: ChatTypeFilter!
    $offset: Int!
    $limit: Int!
    $tagFilter: TagFilterInput
    $messagingChannel: ChatType
    $daysSinceLastReceivedMessageWithIn: Int
  ) {
    Chats(
      input: {
        storeId: $storeId
        chatTypeFilter: $chatTypeFilter
        tagFilter: $tagFilter
        offset: $offset
        limit: $limit
        messagingChannel: $messagingChannel
        daysSinceLastReceivedMessageWithIn: $daysSinceLastReceivedMessageWithIn
      }
    ) {
      hasNext
      chats {
        id
        userName
        avatar
      }
    }
  }
`);

export const GET_INFLUENCER_CATEGORIES = gql(/* GraphQL */ `
  query GetInfluencerCategories {
    InfluencerCategories {
      id
      name
    }
  }
`);

export const GET_LINE_RICH_MENU_POSTBACK_OPTIONS = gql(/* GraphQL */ `
  query GetLineRichMenuPostbackOptions($input: String!) {
    LineRichMenu(input: $input) {
      id
      title
      template {
        id
        actions {
          ... on LineRichMenuPostbackAction {
            trigger
          }
        }
      }
    }
  }
`);

export const SEARCH_MKP_LISTING_V2 = gql(/* GraphQL */ `
  query SearchMkpListingV2($input: GetAnyChatSaleChannelProductsRequest!) {
    AnyChatSaleChannelProducts(input: $input) {
      id
      name
      saleChannelType
    }
  }
`);
